<template>
    <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
        <div class="main-navbar">
            <nav class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0">
                <a class="navbar-brand w-100 mr-0" href="#">
                    <div class="d-table m-auto">
                        <img id="main-logo" class="d-inline-block align-top mr-1 header__image" src="@/assets/images/logo2.png" alt="Shards Dashboard">
                    </div>
                </a>
                <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none" @click="handleToggleSidebar()">
                    <i class="material-icons">&#xE5C4;</i>
                </a>
            </nav>
        </div>
        <div class="nav-wrapper">
            <div v-if="showItems && items" v-for="(nav, navIdx) in items" :key="navIdx">
                <h6 v-if="nav.title" class="main-sidebar__nav-title">{{ nav.title }}</h6>
                <d-nav v-if="typeof nav.items !== 'undefined' && nav.items.length" class="nav--no-borders flex-column">
                    <li v-for="(item, navItemIdx) in nav.items" :key="navItemIdx" class="nav-item dropdown">
                        <d-link :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']" :to="item.to" v-d-toggle="`snc-${navIdx}-${navItemIdx}`">
                            <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore" />
                                <span v-if="item.title">{{ item.title }}</span>
                            <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter" />
                        </d-link>
                        <d-collapse v-if="item.items && item.items.length" :id="`snc-${navIdx}-${navItemIdx}`" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
                            <d-dropdown-item v-for="(subItem, subItemIdx) in item.items" :key="subItemIdx" :href="subItem.href" :to="subItem.to">
                                {{ subItem.title }}
                            </d-dropdown-item>
                        </d-collapse>
                    </li>
                    <li class="nav-item dropdown">
                        <d-link :class="['nav-link', items && items.length ? 'dropdown-toggle' : '']"  v-d-toggle.domain>
                            <div class="item-icon-wrapper">
                                <i class="material-icons">public</i>
                            </div>
                           Domains
                        </d-link>
                        <d-collapse id="domain" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
                            <d-dropdown-item class="domain-items" v-for="(subItem, subItemIdx) in userInfo.websites" :id="subItem.id" :key="subItemIdx" :to="'/network/' + subItem.id">
                                {{ subItem.domain }}
                            </d-dropdown-item>
                            <d-dropdown-item  v-if="checkPermission(permissionTypes.websiteWrite)" to="/add-domain">
                              Add Domain
                          </d-dropdown-item>
                        </d-collapse>
                    </li>
                </d-nav>
            </div>
      </div>

      <div class="nav-wrapper">
        <div v-if="showItems && items" v-for="(nav, navIdx) in items" :key="navIdx">
          <h6 v-if="nav.title" class="main-sidebar__nav-title">{{ nav.title }}</h6>
          <d-nav v-if="typeof nav.items !== 'undefined' && nav.items.length" class="nav--no-borders flex-column">
            <li v-for="(item, navItemIdx) in nav.items" :key="navItemIdx" class="nav-item dropdown">
              <d-link :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']" :to="item.to" v-d-toggle="`snc-${navIdx}-${navItemIdx}`">
                <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore" />
                <span v-if="item.title">{{ item.title }}</span>
                <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter" />
              </d-link>
              <d-collapse v-d-toggle="`snc-${navIdx}-${navItemIdx}`" v-if="item.items && item.items.length" :id="`snc-${navIdx}-${navItemIdx}`" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
                <d-dropdown-item v-for="(subItem, subItemIdx) in item.items" :key="subItemIdx" :href="subItem.href" :to="subItem.to">
                  {{ subItem.title }}
                </d-dropdown-item>
              </d-collapse>
            </li>
          </d-nav>
        </div>
      </div>
    </aside>
</template>

<script>
import Vue from 'vue';
import permissions from '../../../mixins/permissions';
export default {
    name: 'main-sidebar',
    mixins: [permissions],
    props: {
        hideLogoText: {
            type: Boolean,
            default: false,
        },

        items: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            sidebarVisible: false
        };
    },

    beforeDestroy() {
        this.$eventHub.$off('toggle-sidebar');
    },

    methods: {
        handleToggleSidebar() {
            this.sidebarVisible = !this.sidebarVisible;
        },
    },

    created () {
        this.$eventHub.$on('toggle-sidebar', this.handleToggleSidebar);
    },

    computed: {
      userInfo () {
          return this.$store.getters.userInfo
      },
      showItems () {
          return this.userInfo.role && this.userInfo.role.name !== 'Accountant'
      },
    },

    watch: {
        $route(to, from) {
            if(this.sidebarVisible) {
                this.handleToggleSidebar()
            }
        }
    },
};
</script>

<style lang="scss">
  .main-sidebar {
    .item-icon-wrapper {
      display: inline-block;
    }
    .dropdown-menu {
      display: block;
    }
  }
</style>
